module.exports = __webpack_public_path__ + "static/media/no2_100.b5db7688.png";